import { Location } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common/common.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { AppRoute } from 'src/app/shared/constants/app-route.constant';
import { PHOTOBOOTH_MODAL_OPTIONS } from 'src/app/shared/constants/modal-options.constant';
import {
  HiddenMenuMode,
  InterfaceText,
  PinDialogVerifyResult,
  StorageKey,
} from 'src/app/shared/constants/global-config.constant';


@Component({
  selector: 'app-payment-or-promo',
  templateUrl: './payment-or-promo.component.html',
  styleUrls: ['./payment-or-promo.component.scss']
})
export class PaymentOrPromoComponent {

  constructor(
    private router: Router,
    private ngbModal: NgbModal,
    public commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
    private themeService: ThemeService
  ) {

    this.activatedRoute.queryParams.subscribe(params => {
      this.isOpenPinDialog = params['pin'];
    })

  }

  TXT_PAYMENT_OPTION_DIALOG_HEADER = InterfaceText.PAYMENT_OPTION_DIALOG_HEADER;
  TXT_PAYMENT_OPTION_DIALOG_TITLE = InterfaceText.PAYMENT_OPTION_DIALOG_TITLE;
  TXT_PAYMENT_OPTION_DIALOG_DEL_BUTTON = InterfaceText.PAYMENT_OPTION_DIALOG_DEL_BUTTON;
  TXT_PAYMENT_OPTION_STANDBY_TEXT = InterfaceText.PAYMENT_OPTION_STANDBY_TEXT;
  TXT_PAYMENT_OPTION_PROMOTION_BUTTON = InterfaceText.PAYMENT_OPTION_PROMOTION_BUTTON;
  TXT_PAYMENT_OPTION_PROMOTION_BUTTON_QR = InterfaceText.PAYMENT_OPTION_PROMOTION_BUTTON_QR;
  TXT_PAYMENT_OPTION_PROMOTION_BUTTON_TEXT = InterfaceText.PAYMENT_OPTION_PROMOTION_BUTTON_TEXT;
  TXT_PAYMENT_OPTION_PROMOTION_TYPE_SELECT = InterfaceText.PAYMENT_OPTION_PROMOTION_TYPE_SELECT;
  TXT_PAYMENT_OPTION_PROMOTION_TYPE_SELECT_SUBTITLE = InterfaceText.PAYMENT_OPTION_PROMOTION_TYPE_SELECT_SUBTITLE;
  TXT_PAYMENT_OPTION_PAY = InterfaceText.PAYMENT_OPTION_PAY;
  TXT_PAYMENT_OPTION_PROMOTION_HEADER = InterfaceText.PAYMENT_OPTION_PROMOTION_HEADER;
  TXT_GLOBAL_BACK_BUTTON = InterfaceText.GLOBAL_BACK_BUTTON;
  TXT_PAYMENT_OPTION_ENTER_YOUR_PROMOTION_CODE = InterfaceText.PAYMENT_OPTION_ENTER_YOUR_PROMOTION_CODE;

  theme = this.themeService.getTheme();

  show = true;

  modalRef: NgbModalRef;
  typed: string = "";
  promoError: boolean = false;
  standbyText: string = InterfaceText.PAYMENT_OPTION_STANDBY_TEXT;
  showCamLoad: boolean = true;
  isOffline: boolean = false;
  showKeyboard = false;
  enteredPromo = '';

  isGotDiscount: boolean = false;
  fullPrice: number = 0;
  vatPrice: number = 0;
  discountPrice: number = 0;
  deductedPrice: number = 0;
  vatPercent: number = 0
  totalPrice: number = 0;

  isFreeWhitelist: boolean = false;
  showPayButton: boolean = true;
  showPromoButton: boolean = true;

  currentHiddenMenuMode: HiddenMenuMode = HiddenMenuMode.NONE;
  @ViewChild('content') content;
  isOpenPinDialog = false;

  @ViewChild('introContent') introContent: NgbModalRef;
  @ViewChild('stepTwoContent') stepTwoContent: NgbModalRef;
  @ViewChild('webcamVideo') webcamVideo: ElementRef<HTMLVideoElement>;
  @ViewChild('overlayCanvas') overlayCanvas: ElementRef<HTMLCanvasElement>;

  faceCount: number = 0;
  private _detectionInterval: any;
  private stream: MediaStream | null = null;
  private modelsLoaded: boolean = false;
  private displaySize = { width: 0, height: 0 };
  isPersonCountEnough: boolean = false;
  currentModalRef: NgbModalRef | null = null;

  async ngAfterViewInit() {
    this.commonService.isLoading = true;
    try {
      // await this.checkFreeWhiteList();
      await this.checkHidePayButton();
      await this.checkHidePromoButton();

      if (this.isOpenPinDialog) {
        this.openPIN(this.content, null)
      }

      const useFaceDetection = localStorage.getItem(StorageKey.USE_FACE_DETECTION);
      if (useFaceDetection === 'true') {

        try {
          const localPath = '/assets/models';
          await faceapi.nets.tinyFaceDetector.loadFromUri(localPath);
          console.log('Loaded tinyFaceDetector from', localPath);
          this.modelsLoaded = true;
        }
        catch (err) {
          console.warn('Failed to load tinyFaceDetector from /assets/models', err);
          this.modelsLoaded = false;
        }



        this.openIntroContent();

        if (this.modelsLoaded) {
          this.startWebcamAndDetect();
        }
        else {
          console.warn('Face detection models not loaded; skipping detection.');
        }
      }

    }
    catch (err) {
      console.log(err);
    }
    finally {
      this.commonService.isLoading = false;
    }
  }

  openIntroContent() {
    this.currentModalRef = this.modalService.open(this.introContent, { ...PHOTOBOOTH_MODAL_OPTIONS, windowClass: 'intro-modal' });
  }

  closeIntroContent() {
    this.currentModalRef?.close();
  }

  async checkHidePayButton() {
    const configResult = this.commonService.getConfigSculptureBranchHidePay();
    if (configResult) {
      if (configResult.length > 0) {
        if (configResult.includes(localStorage.getItem(StorageKey.BRANCH_CODE))) {
          this.showPayButton = false;
        }
      }
      console.log(configResult);
    }
  }

  async checkHidePromoButton() {
    const configResult = this.commonService.getConfigSculptureHidePromoButton();
    if (configResult) {
      if (configResult.length > 0) {
        if (configResult.includes(localStorage.getItem(StorageKey.BRANCH_CODE))) {
          this.showPromoButton = false;
        }
      }
    }
  }

  openPIN(content, mode: string) {
    console.log(content);
    if (mode === 'typepromo') {
      this.modalRef = this.ngbModal.open(content, PHOTOBOOTH_MODAL_OPTIONS);
    }
    else if (mode === 'promotion') {
      this.modalRef.dismiss();
      this.modalRef = this.ngbModal.open(content, PHOTOBOOTH_MODAL_OPTIONS);
    }
    else if (mode === 'promotiontext') {
      this.modalRef.dismiss();
      this.modalRef = this.ngbModal.open(content, { ...PHOTOBOOTH_MODAL_OPTIONS, backdrop: false });
      this.showKeyboard = true;
    }
    else {
      this.location.replaceState(`/payment-or-promo?pin=true`);
      this.modalRef = this.ngbModal.open(content, PHOTOBOOTH_MODAL_OPTIONS);
    }
  }

  goToPrice() {
    localStorage.setItem(StorageKey.PROMO_USE, 'false');
    this.router.navigate([AppRoute.PAYMENT_PRICE]);
  }

  goToHome() {
    this.router.navigate([AppRoute.HOME]);
  }

  goToPromoType() {
    this.router.navigate([AppRoute.PROMO_TYPE]);
  }

  setOnline() {
    this.isOffline = false;
  }

  setOffline() {
    this.isOffline = true;
  }

  handleCloseDialog(data: PinDialogVerifyResult) {
    console.log('Close dialog')
    this.modalRef.dismiss();
    this.showKeyboard = false;
    this.showCamLoad = true;
    this.location.replaceState(`/payment-or-promo`);
  }

  handleSuccessVerify(data: PinDialogVerifyResult) {
    console.log('Success verify')
    this.modalRef.close();
    localStorage.setItem(StorageKey.IS_PIN_USE, 'true');
    this.router.navigate([AppRoute.PAYMENT_SUCCESS]);
  }

  ngOnDestroy(): void {
    // Leaving the page takes the staff PIN dialog with it; its own ngOnDestroy cancels a
    // pending approval request (D35).
    this.modalRef?.dismiss();
    if (this._detectionInterval) {
      clearInterval(this._detectionInterval);
    }
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop());
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    const videoEl = document.getElementById('intro-webcam') as HTMLVideoElement;
    const canvasEl = document.getElementById('intro-overlay') as HTMLCanvasElement;
    if (videoEl && canvasEl) {
      this.updateCanvasSize(videoEl, canvasEl);
    }
  }

  private updateCanvasSize(videoEl: HTMLVideoElement, canvasEl: HTMLCanvasElement) {
    const style = window.getComputedStyle(videoEl);
    const displayWidth = parseInt(style.width || videoEl.videoWidth.toString(), 10) || videoEl.videoWidth;
    const displayHeight = parseInt(style.height || videoEl.videoHeight.toString(), 10) || videoEl.videoHeight;

    canvasEl.width = displayWidth;
    canvasEl.height = displayHeight;
    canvasEl.style.width = `${displayWidth}px`;
    canvasEl.style.height = `${displayHeight}px`;

    this.displaySize = { width: displayWidth, height: displayHeight };
    faceapi.matchDimensions(canvasEl as any, this.displaySize);
  }

  onBack() {
    this.closeIntroContent();
    this.router.navigate([AppRoute.HOME]);
  }

  private async startWebcamAndDetect() {
    try {
      // try to get the actual elements from DOM (modal may not have attached ViewChild yet)
      const videoEl = document.getElementById('intro-webcam') as HTMLVideoElement;
      const canvasEl = document.getElementById('intro-overlay') as HTMLCanvasElement;
      if (!videoEl || !canvasEl) {
        console.warn('webcam or canvas element not found in DOM yet');
        return;
      }

      // request camera
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ video: { width: 640, height: 480 }, audio: false });
      }
      catch (err) {
        console.error('getUserMedia failed', err);
        // show fallback -- leave faceCount 0 and return
        return;
      }

      videoEl.srcObject = this.stream;

      // ensure the video plays (some browsers require explicit play call)
      await videoEl.play().catch(e => {
        console.warn('video play() rejected', e);
      });

      // Use computed display size so canvas overlays perfectly
      this.updateCanvasSize(videoEl, canvasEl);

      const options = new faceapi.TinyFaceDetectorOptions({ inputSize: 224, scoreThreshold: 0.5 });

      // detection loop (use requestAnimationFrame via interval wrapper)
      this._detectionInterval = setInterval(async () => {
        try {
          if (videoEl.readyState < 2) return; // not enough data

          const detections = await faceapi.detectAllFaces(videoEl, options);

          this.faceCount = detections.length;
          if (this.faceCount >= 2) {
            this.isPersonCountEnough = true;
          }

          // draw detections
          const resizedDetections = faceapi.resizeResults(detections, this.displaySize);
          const ctx = canvasEl.getContext('2d');
          if (ctx) {
            ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
            faceapi.draw.drawDetections(canvasEl as any, resizedDetections as any);
          }
        }
        catch (e) {
          // handle model-not-loaded errors gracefully
          console.warn('Detection error (skipping this frame):', e);
          if (String(e).includes('TinyYolov2 - load model') || String(e).includes('load model before inference')) {
            // stop detection to avoid flooding console; models are not available
            clearInterval(this._detectionInterval);
            this._detectionInterval = null;
            console.warn('Stopped detection loop because required models are not loaded.');
          }
        }
      }, 200);

    }
    catch (err) {
      console.error('Error starting webcam', err);
    }
  }

  goToStepTwo() {
    this.closeIntroContent();
    const isFreeWhitelist = localStorage.getItem(StorageKey.IS_FREE_WHITELIST);
    if (isFreeWhitelist === 'true') {
      this.router.navigate([AppRoute.PAYMENT_SUCCESS]);
    }
    else {

    }
  }

}
